import * as React from 'react';

import { ICountersStore, ICurrentUser } from '@stores';

import { getConfig } from '@base/constants';

interface IUseCountersWatchersProps {
	countersStore: ICountersStore;
	currentUserStore: ICurrentUser;
}

export const useCountersWatchers = ({
	countersStore,
	currentUserStore,
}: IUseCountersWatchersProps) => {
	function watchCountersNotify() {
		const { currentUser } = currentUserStore;
		const options = { user: currentUser, isMobile: true };
		let updateInterval = getConfig().countersUpdateInterval;

		// минимальный интервал обновления 1 секунда;
		updateInterval = updateInterval > 0 && updateInterval < 1000 ? 1000 : updateInterval;
		updateInterval && void countersStore.watchNotify(options, updateInterval);
	}

	React.useEffect(() => {
		if (currentUserStore.isMyCreated && !countersStore.isWatchingNotify) {
			watchCountersNotify();
		}

		return () => {
			countersStore.stopWatchingNotify();
		};
	}, [currentUserStore.isMyCreated]);
};
